import Account from "app/Account/config";
import Agent from "app/Agent/config";
import BackofficePayment from "app/BackofficePayment/config";
import Booking from "app/Booking/config";
import DN from "app/DN/config";
import Dings from "app/Dings/config";
import Event from "app/Event/config";
import Gastrohub from "app/Gastrohub/config";
import Inventory from "app/Inventory/config";
import ManageTables from "app/ManageTables/config";
import OnlineBooking from "app/OnlineBooking/config";
import Order from "app/Order/config";
import OrderV2 from "app/OrderV2/config";
import Payment from "app/Payment/config";
import Portal from "app/Portal/config";
import Print from "app/Print/config";
import PotentialClients from "app/PotentialClients/config";
import Sellers from "app/Sellers/config";
import Translate from "app/Translate/config";

const serviceProviders = {
    Account,
    Agent,
    BackofficePayment,
    Booking,
    DN,
    Dings,
    Event,
    Gastrohub,
    Inventory,
    ManageTables,
    OnlineBooking,
    OrderV2,
    Order,
    Payment,
    Portal,
    Print,
    PotentialClients,
    Sellers,
    Translate,
};

export default serviceProviders;
